import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TENANT_VIEWS } from './tenantPages';
import UserSources from '../../sources/user';
import translations from '../../translations';
import { addNotification } from '../../actions/reduxActions/notification';

export class UserDetails extends Component {

    state = {
        firstName: '',
        lastName: '',
        email: '',
    };

    updateField(fieldName) {
        return ({ target }) => this.setState({
            [fieldName]: target.value,
        });
    }

    addUser({ authenticationToken, tenantId, navigateTo, firstName, lastName, email }) {
        return UserSources.addUserToCurrentTenant({ authenticationToken, tenantId, firstName, lastName, email })
            .then(
                () => navigateTo(TENANT_VIEWS.tenant),
                error => this.props.addNotification({
                    type: 'error',
                    message: error.message,
                    isPersistent: true,
                }),
            );
    }

    render() {

        const { authenticationToken, tenantId, navigateTo } = this.props;

        return (
            <React.Fragment>
                <div className="admin-page">
                    <p>
                        { translations['enter new flow builder details'] }
                    </p>

                    <div className="form-group">
                        <label>
                            First Name
                            <span className="input-required"> *</span>
                        </label>
                        <input
                            maxLength="255"
                            required
                            className="form-control admin-input user-details-first"
                            type="text"
                            onInput={this.updateField('firstName')}
                        />
                    </div>

                    <div className="form-group">
                        <label>
                            Last Name
                            <span className="input-required"> *</span>
                        </label>
                        <input
                            maxLength="255"
                            required
                            className="form-control admin-input user-details-last"
                            type="text"
                            onInput={this.updateField('lastName')}
                        />
                    </div>

                    <div className="form-group">
                        <label>
                            Email
                            <span className="input-required"> *</span>
                        </label>
                        <input
                            maxLength="255"
                            required
                            className="form-control admin-input user-details-email"
                            type="email"
                            onInput={this.updateField('email')}
                        />
                    </div>

                </div>

                <div className="mw-footer container-fluid">

                    <button
                        type="button"
                        className="outcome btn btn-default"
                        onClick={() => navigateTo(TENANT_VIEWS.tenant)}
                    >
                        Back
                    </button>

                    <button
                        type="button"
                        className="btn btn-primary outcome user-details-register"
                        onClick={() => this.addUser({
                            authenticationToken,
                            tenantId,
                            navigateTo,
                            ...this.state,
                        })}
                    >
                        Register Builder
                    </button>
                </div>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = {
    addNotification,
};

export default connect(
    null,
    mapDispatchToProps,
)(UserDetails);
